<template>
  <div>
    <el-form
      :model="form"
      :inline="true"
      size="mini"
      label-width="100px"
      class="hidden-xl-only"
    >
      <el-form-item style="float: right">
        <el-link
          type="primary"
          :underline="false"
          @click="collapse = !collapse"
          style="margin-right: 10px"
          >{{ collapse ? "折叠" : "展开" }}</el-link
        >
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" @click="onReset">重置</el-button>
      </el-form-item>
      <el-form-item label="店铺" class="first-lable">
        <el-select v-model="form.storeCode" filterable placeholder="全部">
          <el-option
            v-for="item in useObjectList"
            :label="item.name"
            :key="item.code"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="空间">
        <el-autocomplete
          class="form-input"
          v-model="form.space"
          :fetch-suggestions="querySkuList"
          @focus="onSkuCodeFocus(0)"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="风格">
        <el-autocomplete
          class="form-input"
          v-model="form.style"
          :fetch-suggestions="querySkuList"
          @focus="onSkuCodeFocus(1)"
        ></el-autocomplete>
      </el-form-item>
      <span class="form-number-input price">
        <el-form-item label="日常活动到手价">
          <el-input-number
            v-model="form.priceStart"
            :controls="false"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="~" class="date-number-middle">
          <el-input-number
            v-model="form.priceEnd"
            :controls="false"
          ></el-input-number>
        </el-form-item>
      </span>
      <transition name="el-zoom-in-top">
        <div v-if="collapse" class="search-header-collapse">
          <el-popover
            placement="top-start"
            title="常用选项"
            width="auto"
            trigger="hover"
          >
            <el-row>
              <el-col>
                <!-- <el-button
            type="primary"
            v-for="(item) in palyTime"
            @click="searchName(item)"
            :key="item"
            >{{ item }}</el-button
          > -->
                <el-button type="primary" @click="searchName('近一周')"
                  >近一周</el-button
                >
                <el-button type="primary" @click="searchName('近30天')"
                  >近30天</el-button
                >
                <el-button type="primary" @click="searchName('近半年')"
                  >近半年</el-button
                >
                <el-button
                  type="primary"
                  @click="searchName('近一年')"
                  v-if="!timeType"
                  >近一年</el-button
                >
              </el-col>
            </el-row>
            <span class="form-date-picker" slot="reference">
              <el-form-item label="时间">
                <el-date-picker
                  v-model="form.payTimeStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :clearable="timeType ? false : true"
                  :editable="timeType ? false : true"
                  :picker-options="timeType ? pickerOptions : timeNone"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="至" class="date-picker-middle">
                <el-date-picker
                  v-model="form.payTimeEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :clearable="timeType ? false : true"
                  :editable="timeType ? false : true"
                  :picker-options="timeType ? pickerOptions : timeNone"
                ></el-date-picker>
              </el-form-item>
            </span>
          </el-popover>
        </div>
      </transition>
    </el-form>
    <el-form
      :model="form"
      :inline="true"
      size="mini"
      label-width="100px"
      class="hidden-lg-and-down"
    >
      <el-form-item style="float: right">
        <!-- <el-link type="primary" :underline="false" @click="collapse = !collapse;" style="margin-right: 10px;">{{collapse?'折叠':'展开'}}</el-link> -->
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" @click="onReset">重置</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-switch
          v-model="dataRange"
          active-text="全部"
          inactive-text="近半年"
          @change="switchType"
          style="margin-right: 15px; padding-left: 10px"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="店铺" class="first-lable">
        <el-select v-model="form.storeCode" filterable placeholder="全部">
          <el-option
            v-for="item in useObjectList"
            :label="item.name"
            :key="item.code"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="空间">
        <el-autocomplete
          class="form-input"
          v-model="form.space"
          :fetch-suggestions="querySkuList"
          @focus="onSkuCodeFocus(0)"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="风格">
        <el-autocomplete
          class="form-input"
          v-model="form.style"
          :fetch-suggestions="querySkuList"
          @focus="onSkuCodeFocus(1)"
        ></el-autocomplete>
      </el-form-item>
      <span class="form-number-input price">
        <el-form-item label="日常活动到手价">
          <el-input-number
            v-model="form.priceStart"
            :controls="false"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="~" class="date-number-middle">
          <el-input-number
            v-model="form.priceEnd"
            :controls="false"
          ></el-input-number>
        </el-form-item>
      </span>
      <el-popover
        placement="top-start"
        title="常用选项"
        width="auto"
        trigger="hover"
      >
        <el-row>
          <el-col>
            <el-button type="primary" @click="searchName('近一周')"
              >近一周</el-button
            >
            <el-button type="primary" @click="searchName('近30天')"
              >近30天</el-button
            >
            <el-button type="primary" @click="searchName('近半年')"
              >近半年</el-button
            >
            <el-button
              type="primary"
              @click="searchName('近一年')"
              v-if="!timeType"
              >近一年</el-button
            >
            <!-- <el-button
            type="primary"
            v-for="(item) in palyTime"
            @click="searchName(item)"
            :key="item"
            >{{ item }}</el-button
          > -->
          </el-col>
        </el-row>
        <span class="form-date-picker" slot="reference">
          <el-form-item label="时间">
            <el-date-picker
              v-model="form.payTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :clearable="timeType ? false : true"
              :editable="timeType ? false : true"
              :picker-options="timeType ? pickerOptions : timeNone"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="至" class="date-picker-middle">
            <el-date-picker
              v-model="form.payTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :clearable="timeType ? false : true"
              :editable="timeType ? false : true"
              :picker-options="timeType ? pickerOptions : timeNone"
            ></el-date-picker>
          </el-form-item>
        </span>
      </el-popover>
      <!-- <transition name="el-zoom-in-top">
        <div v-if="collapse" class="search-header-collapse">
          
        </div>
      </transition> -->
    </el-form>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";
import moment from "moment";
export default {
  model: {
    prop: "formData",
    event: "input",
  },
  props: ["formData"],
  data() {
    return {
      collapse: false,
      form: {},
      useObjectList: [],
      optionsn: [],
      dataRange: false,
      inputIndex: 9,
      timeNone: {},
      pickerOptions: {
        //disabled为函数，返回值为布尔值，
        disabledDate: (time) => {
          var curDate = new Date().getTime();
          var halfYear = (365 / 2) * 24 * 3600 * 1000;
          var pastResult = curDate - halfYear;
          var pastDate = new Date(pastResult),
            pastYear = pastDate.getFullYear(),
            pastMonth = pastDate.getMonth() + 1,
            pastDay = new Date().getDate();
          var minYear = pastYear + "-" + pastMonth + "-" + pastDay;
          if (this.timeType) {
            return (
              time > Date.now() ||
              time.getTime() < new Date(JSON.stringify(minYear))
            );
          } else {
            return;
          }
        },
      },
    };
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
    collapse(val) {
      this.$emit("onCollapse", val);
    },
  },
  computed: {
    palyTime() {
      let data = ["近一周", "近30天", "近半年", "近一年"];
      return data;
    },
    timeType() {
      if (
        !this.dataRange &&
        this.form.payTimeStart <
          moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
      ) {
        this.$set(
          this.form,
          "payTimeStart",
          moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
        );
        return true;
      } else if (
        !this.dataRange &&
        this.form.payTimeStart <=
          moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
      ) {
        return true;
      } else if (this.dataRange) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.$set(
      this.form,
      "payTimeStart",
      moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
    );
    this.$set(
      this.form,
      "payTimeEnd",
      moment(new Date()).subtract("months").format("YYYY-MM-DD")
    );
    this.getDataRange();
    this.salesGetStore();
    this.getOptionsn();
  },
  methods: {
    onSearch() {
      if (!this.form.payTimeStart || !this.form.payTimeEnd) {
        this.$message.error("时间信息未填写，请填写后再搜索");
        return;
      } else if (!this.form.storeCode) {
        this.$message.error("店铺信息未选择，请填写后再搜索");
        return;
      } else if (!this.form.space) {
        this.$message.error("空间信息未填写，请填写后再搜索");
        return;
      }
      this.$emit("search", this.form);
    },
    onReset() {
      this.form = {
        storeCode: this.form.storeCode,
        payTimeStart: moment(new Date())
          .subtract(6, "months")
          .format("YYYY-MM-DD"),
        payTimeEnd: moment(new Date()).subtract("months").format("YYYY-MM-DD"),
        // planTimeStart: moment(new Date())
        //   .subtract(6, "months")
        //   .format("YYYY-MM-DD"),
        // planTimeEnd: moment(new Date()).subtract("months").format("YYYY-MM-DD"),
      };
      this.$nextTick((_) => {
        this.$emit("reset");
      });
    },

    searchName(item) {
      let week = moment(new Date())
        .subtract(1, "weeks")
        .subtract(-1, "days")
        .format("YYYY-MM-DD");
      let day = moment(new Date())
        .subtract(30, "days")
        .subtract(-1, "days")
        .format("YYYY-MM-DD");
      let month = moment(new Date()).subtract(6, "months").format("YYYY-MM-DD");
      let year = moment(new Date()).subtract(1, "years").format("YYYY-MM-DD");
      let time = moment(new Date()).subtract("months").format("YYYY-MM-DD");
      if (item == "近一周") {
        this.$set(this.form, "payTimeStart", week);
      } else if (item == "近30天") {
        this.$set(this.form, "payTimeStart", day);
      } else if (item == "近半年") {
        this.$set(this.form, "payTimeStart", month);
      } else {
        this.$set(this.form, "payTimeStart", year);
      }
      this.$set(this.form, "payTimeEnd", time);
    },

    getDataRange() {
      this.$q.intelligentRecom.getDataRange({}).then((res) => {
        res.data == "Y" ? (this.dataRange = true) : (this.dataRange = false);
      });
    },
    switchType() {
      let params = {
        params: {
          dataRange: this.dataRange ? "Y" : "N",
        },
      };
      this.$q.intelligentRecom.updateDataRange({ params }).then((res) => {});
    },

    salesGetStore() {
      this.$q.intelligentRecom.getStore({}).then((res) => {
        this.useObjectList = res.data;
        if (res.data[0].whetherDef == "1") {
          this.$set(this.form, "storeCode", res.data[0].code);
        }
      });
    },
    getOptionsn() {
      this.$q.intelligentRecom.optionsn({}).then((res) => {
        this.optionsn = res.data;
      });
    },
    onSkuCodeFocus(index) {
      this.inputIndex = index
      if (index == 0) {
        this.inputData = this.optionsn.space;
      } else {
        this.inputData = this.optionsn.style;
      }
    },
    querySkuList(queryString, cb) {
      let data = this.inputData;
      if (!data) {
        cb([]);
        return;
      }
      if(this.inputIndex == 0) {
        var results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter((item) =>
              item.toLowerCase().includes(queryString.toLowerCase())
            )
        : data.allOptions
        ? data.allOptions.map((v) => v.criteriaContent)
        : [];
      }else {
        var results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter((item) =>
              item.toLowerCase().includes(queryString.toLowerCase())
            )
        : data.commonlyUsed
        ? data.commonlyUsed.map((v) => v.criteriaContent)
        : [];
      }
      

      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
  },
};
</script>
<style lang="stylus" scoped>
>>> .el-form {
  width: 100%;
  margin-top: 10px;
}

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}

>>> .el-form-item__label {
  width: 60px !important;
}

.price >>> .el-form-item__label {
  width: 120px !important;
}

.search-header-collapse {
  // position absolute
  background-color: #ffffff;
  width: 100%;
  left: 0px;
  padding: 5px 0px 0px 0;
  margin-top: -5px;
  box-sizing: border-box;
  // z-index 999
  // box-shadow 0px 5px 5px rgba(0,0,0,.1)
}

>>> .form-number-input .el-input__inner {
  wdith: 100px !important;
}

// >>> .form-date-picker .el-input--mini .el-input__inner {
// width: 120px;
// padding: 0px 15px 0px 30px;
// }
>>> .form-date-picker .el-date-editor {
  width: 130px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 80px !important;
}

>>> .form-number-input .el-input-number {
  width: 70px !important;
}

>>> .form-number-input {
  display: inline-block;
  padding-right: 20px;
}
</style>